import { render } from "./Post.vue?vue&type=template&id=09100990&scoped=true&lang=pug"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=09100990&lang=sass&scoped=true"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09100990"]])

export default __exports__